import styled from 'styled-components';
import {spacedInputs} from 'styles/fragments';

export default styled.div`
	${spacedInputs};
`;
